<template>
  <ValidationObserver>
    <div class="form-group">
      <ValidationProvider name="gender" vid="gender" v-slot="{ errors }" rules="required">
        <div class="d-flex flex-wrap">
          <div class="custom-control custom-radio mr-4">
            <input type="radio" id="male" value="M" v-model="guest.gender" class="custom-control-input" :class="{ 'is-invalid': errors[0] }" :disabled="report && report.status == 1">
            <label class="custom-control-label" for="male">Moški</label>
          </div>
          <div class="custom-control custom-radio mr-4">
            <input type="radio" id="female" value="F" v-model="guest.gender" class="custom-control-input" :class="{ 'is-invalid': errors[0] }" :disabled="report && report.status == 1">
            <label class="custom-control-label" for="female">Ženska</label>
          </div>
        </div>
        <span class="text-danger">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>

    <div class="form-group">
      <label for="guest.name.first">{{ $t('name.first') }}</label>
      <ValidationProvider name="first name" vid="name.first" v-slot="{ errors }" rules="required">
        <input class="form-control" v-model="guest.name.first" :class="{ 'is-invalid': errors[0] }" :disabled="report && report.status == 1">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <ValidationProvider name="last name" vid="name.last" v-slot="{ errors }" rules="required">
        <label for="guest.name.last">{{ $t('name.last') }}</label>
        <input class="form-control" v-model="guest.name.last" :class="{ 'is-invalid': errors[0] }" :disabled="report && report.status == 1">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>

    <div class="form-group">
      <ValidationObserver v-slot="{ errors }">
        <label>{{ $t('dob') }}</label>
        <div class="row">
          <div class="col-3 pr-1">
            <ValidationProvider name="day of birth" vid="dob.day" v-slot="{ errors }" rules="required">
              <select class="form-control" :class="{ 'is-invalid': errors[0] }" v-model="guest.dob.day" @change="changeDOB" :disabled="report && report.status == 1">
                <option value="" disabled></option>
                <option v-for="day in 31" v-bind:value="day">{{day}}</option>
              </select>
            </ValidationProvider>
          </div>
          <div class="col-5 pr-1 pl-1">
            <ValidationProvider name="month of birth" vid="dob.month" v-slot="{ errors }" rules="required">
              <select class="form-control" :class="{ 'is-invalid': errors[0] }" v-model="guest.dob.month" @change="changeDOB" :disabled="report && report.status == 1">
                <option value="" disabled></option>
                <option value="1">Januar</option>
                <option value="2">Februar</option>
                <option value="3">Marec</option>
                <option value="4">April</option>
                <option value="5">Maj</option>
                <option value="6">Junij</option>
                <option value="7">Julij</option>
                <option value="8">Avgust</option>
                <option value="9">September</option>
                <option value="10">Oktober</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </select>
            </ValidationProvider>
          </div>
          <div class="col-4 pl-1">
            <ValidationProvider name="year of birth" vid="dob.year" v-slot="{ errors }" rules="required">
              <select class="form-control" :class="{ 'is-invalid': errors[0] }" v-model="guest.dob.year" @change="changeDOB" :disabled="report && report.status == 1">
                <option value="" disabled></option>
                <option v-for="year in 121" v-bind:value="nextYear - year">{{nextYear - year}}</option>
              </select>
            </ValidationProvider>
          </div>
        </div>
        <span class="text-danger" v-if="errors['dob.day'] || errors['dob.month'] || errors['dob.year']">{{ errors['dob.day'][0] || errors['dob.month'][0] || errors['dob.year'][0] }}</span>
      </ValidationObserver>
    </div>
    <div class="form-group">
      <label for="guest.country">{{ $t('country') }}</label>
      <ValidationProvider name="državljanstvo" vid="country" v-slot="{ errors }" rules="required">
        <select class="form-control" v-model="guest.country" :class="{ 'is-invalid': errors[0] }" :disabled="report && report.status == 1">
          <option v-for="country in countries" v-bind:value="country.code">{{country.name}}</option>
        </select>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
  </ValidationObserver>
</template>

<script>
  const moment = require('moment');
  const countryList = require('country-list');

  export default {
    name: 'Guest',
    props: ['guest', 'changeDOB', 'report'],
    data: () => ({
      countries: countryList.getData().sort((a, b) => a.name >= b.name ? 1 : -1),
      nextYear: Number(moment().add(1, 'year').format('YYYY'))
    }),
  }
</script>

<i18n>
{
  "en": {
    "name": {
      "first": "First name",
      "last": "Last name"
    },
    "dob": "Date of birth",
    "country": "Nationality"
  },
  "sl": {
    "name": {
      "first": "Ime",
      "last": "Priimek"
    },
    "dob": "Datum rojstva",
    "country": "Državljanstvo"
  }
}
</i18n>
